// TC-PDF-014: agregadas las variantes compuestas 'MED SUP' y 'MED INF' para
// implantes de orden con 4 capas (Superior / Medio Superior / Medio Inferior /
// Inferior). Las medios variantes redondean igual que MED (cada 5mm).
export type ImplantType = 'INF' | 'MED' | 'SUP' | 'EXT' | 'MED SUP' | 'MED INF';

export function roundImplantLength(
    value: number,
    type: string
): number {

    if (!Number.isFinite(value)) {
        throw new Error('roundImplantLength: value must be a valid number');
    }

    const base = Math.ceil(value / 5) * 5;

    switch (type) {

        case 'INF':
        case 'MED':
        case 'MED SUP':
        case 'MED INF':
        case 'EXT':
            return base === value ? base + 5 : base;

        case 'SUP': {
            const remainder = value % 10;

            if (remainder === 0) return value + 5;
            if (remainder <= 5) return Math.floor(value / 10) * 10 + 10;
            return Math.floor(value / 10) * 10 + 15;
        }

        default:
            throw new Error(`Unsupported implant type: ${type}`);
    }
}

export function getMiddleValue(text: string): string | null {
    if (!text) return null;

    const parts = text.split(':');

    if (parts.length < 3) return null;

    return parts[1].trim();
}

/**
 * Abrevia el nombre del material para la solapa de exportación:
 * titanio -> 'Ti', acero -> 'Ac'. Si viene vacío devuelve 'Ti' (default
 * histórico 'TITANIO'); si es un valor desconocido lo devuelve tal cual.
 */
export function abbreviateMaterial(material: string | null | undefined): string {
    const m = (material || '').trim().toLowerCase();
    if (m === 'titanio' || m === 'ti') return 'Ti';
    if (m === 'acero' || m === 'ac') return 'Ac';
    return material ? material.trim() : 'Ti';
}